'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.File = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = require('react-bootstrap');

var _reactIntl = require('react-intl');

var _axwayReactIntl = require('axway-react-intl');

var _axwayReactIntl2 = _interopRequireDefault(_axwayReactIntl);

var _accessibilityUtils = require('../accessibilityUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * File input
 */
var File = exports.File = function (_React$Component) {
	_inherits(File, _React$Component);

	function File(props) {
		_classCallCheck(this, File);

		var _this = _possibleConstructorReturn(this, (File.__proto__ || Object.getPrototypeOf(File)).call(this, props));

		_axwayReactIntl2.default.init(_this);
		_this.onBrowse = _this.onBrowse.bind(_this);
		_this.onFileChange = _this.onFileChange.bind(_this);
		_this.clearFiles = _this.clearFiles.bind(_this);
		_this.onChange = _this.onChange.bind(_this);

		_this.noFileMsg = _this.intl.formatMsg('No file selected');
		_this.noFilesMsg = _this.intl.formatMsg('No files selected');
		_this.browseFileMsg = _this.intl.formatMsg('Browse file');
		_this.browseFilesMsg = _this.intl.formatMsg('Browse files');
		_this.clearFileMsg = _this.intl.formatMsg('Clear file');
		_this.clearFilesMsg = _this.intl.formatMsg('Clear files');

		_this.state = {
			files: _this.getFileList(props.defaultValue) || {}
		};
		return _this;
	}

	_createClass(File, [{
		key: 'getFileList',
		value: function getFileList(value) {
			// defaultValue looks like a File
			if (value && value.name) {
				// Wrap the file so it looks like a FileList
				return { 0: value };
			} else {
				return value;
			}
		}
	}, {
		key: 'onBrowse',
		value: function onBrowse(e) {
			e.preventDefault();
			e.stopPropagation();
			this.inputEl && this.inputEl.click();
		}
	}, {
		key: 'onFileChange',
		value: function onFileChange(e) {
			this.onChange(e.target.files);
		}
	}, {
		key: 'clearFiles',
		value: function clearFiles() {
			this.inputEl.value = '';
			this.onChange();
		}
	}, {
		key: 'onChange',
		value: function onChange(newValue) {
			var _props = this.props,
			    onChange = _props.onChange,
			    multiple = _props.multiple,
			    value = _props.value;

			var cb = function cb() {
				var files = void 0;
				if (newValue) {
					files = multiple ? newValue : newValue[0];
				}
				onChange && onChange(files);
			};
			if (value) {
				// controlled input
				cb();
			} else {
				// uncontrolled input
				this.setState({ files: newValue || {} }, cb);
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props2 = this.props,
			    id = _props2.id,
			    accept = _props2.accept,
			    multiple = _props2.multiple,
			    bsStyle = _props2.bsStyle,
			    bsSize = _props2.bsSize,
			    disabled = _props2.disabled,
			    clearTooltipPlacement = _props2.clearTooltipPlacement,
			    className = _props2.className,
			    value = _props2.value;

			var fileNames = Object.values(this.getFileList(value) || this.state.files).map(function (file) {
				return file.name;
			});
			var hasFiles = !!fileNames.length;
			var tooltip = _react2.default.createElement(
				_reactBootstrap.Tooltip,
				{ id: 'tooltip' },
				multiple ? this.clearFilesMsg : this.clearFileMsg
			);

			return _react2.default.createElement(
				_reactBootstrap.InputGroup,
				{
					id: id,
					bsSize: bsSize,
					className: (0, _classnames2.default)('form-control-file', { 'has-file': hasFiles }, className)
				},
				_react2.default.createElement(_reactBootstrap.FormControl, {
					type: 'text',
					bsSize: bsSize,
					placeholder: multiple ? this.noFilesMsg : this.noFileMsg,
					value: fileNames.join(', '),
					disabled: true
				}),
				_react2.default.createElement(
					_reactBootstrap.InputGroup.Button,
					{ className: 'inputs' },
					_react2.default.createElement(
						_reactBootstrap.Button,
						{
							bsStyle: bsStyle,
							bsSize: bsSize,
							className: 'browse',
							onKeyPress: function onKeyPress(e) {
								return (0, _accessibilityUtils.OnActionKey)(e, _this2.onBrowse);
							},
							onClick: this.onBrowse,
							disabled: disabled
						},
						multiple ? this.browseFilesMsg : this.browseFileMsg
					),
					hasFiles && _react2.default.createElement(
						_reactBootstrap.OverlayTrigger,
						{
							placement: clearTooltipPlacement,
							overlay: tooltip
						},
						_react2.default.createElement(
							_reactBootstrap.Button,
							{
								onClick: this.clearFiles,
								bsSize: bsSize,
								bsStyle: 'link',
								className: 'clear-selection'
							},
							_react2.default.createElement(_reactBootstrap.Glyphicon, { glyph: ' gg icon-GG-cross' })
						)
					),
					_react2.default.createElement('input', {
						ref: function ref(r) {
							_this2.inputEl = r;
						},
						type: 'file',
						accept: accept,
						onChange: this.onFileChange,
						multiple: multiple
					})
				)
			);
		}
	}]);

	return File;
}(_react2.default.Component);

File.propTypes = {
	className: _propTypes2.default.string,

	id: _propTypes2.default.string,

	/**
  * The File or FileList value of the file input to be rendered.
  * Use this for when using as a controlled component.
  */
	value: _propTypes2.default.object,

	/**
  * The default value of the file input.
  * Use this when using as an uncontrolled component
  */
	defaultValue: _propTypes2.default.object,
	/**
  * The file extension or mime type to filter selection.
  */
	accept: _propTypes2.default.string,

	/**
  * Allow multiple selection.
  */
	multiple: _propTypes2.default.bool,

	/**
  * Value changed.
  */
	onChange: _propTypes2.default.func,

	/**
  * Style of the button
  */
	bsStyle: _propTypes2.default.string,

	/**
  * Whether or not the input is disabled
  */
	disabled: _propTypes2.default.bool,

	/**
  * Size of the control
  */
	bsSize: _propTypes2.default.string,

	/**
  * Position of clear file tooltip
  */
	clearTooltipPlacement: _propTypes2.default.string
};

File.defaultProps = {
	bsStyle: 'primary',
	bsSize: 'small',
	clearTooltipPlacement: 'top'
};

var _default = (0, _reactIntl.injectIntl)(File);

exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(File, 'File', 'src/components/FormControl/File.jsx');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/components/FormControl/File.jsx');
}();

;